import { render, staticRenderFns } from "./newEventModal.vue?vue&type=template&id=57be1b4e"
import script from "./newEventModal.vue?vue&type=script&lang=js"
export * from "./newEventModal.vue?vue&type=script&lang=js"
import style0 from "./newEventModal.vue?vue&type=style&index=0&id=57be1b4e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports